import * as React from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { useState } from 'react';
import { NavPath } from '../../paths';
import { LogoHeading } from '../shared/LogoHeading';
import { HelpInfo } from '../parts/HelpInfo';
import { PricePerUnitRate } from '../../data/dataStore';

export interface SplashProps {
    rates: PricePerUnitRate;
}

export const Splash = (props: SplashProps) => {

    const [redirect, setRedirect] = useState(false);

    if (redirect) return <Redirect to={NavPath.who} push />

    return <div className="splash" >
        <div className="click" onClick={() => setRedirect(true)}>
            <LogoHeading subHeading="How many streams do you need to break even?" />
        </div>
        <HelpInfo rates={props.rates} />
    </div>

}